// import { useEffect, useState } from "react";
// import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { loginUser, clearAuthError } from "../slice/authSlice";
// import { homePathFor } from "../components/ProtectedRoute";
// import AuthLayout, { PasswordInput, SubmitButton, AuthAlert } from "../components/AuthLayout";

// // The page the user was trying to open before being sent here (set by
// // ProtectedRoute). Only internal paths are accepted.
// const returnPathFrom = (location) => {
//   const from = location.state?.from;
//   if (!from?.pathname || !from.pathname.startsWith("/") || from.pathname === "/login") return null;
//   return `${from.pathname}${from.search || ""}${from.hash || ""}`;
// };

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user, initialized, status, error } = useSelector((state) => state.auth);
//   const loading = status === "loading";

//   // Clear any old error (e.g. from the Register page) when this page opens.
//   useEffect(() => {
//     dispatch(clearAuthError());
//   }, [dispatch]);

//   // Already signed in (valid 7-day cookie, e.g. after reopening the browser)?
//   // Skip the form and go where they were heading, or to their home page.
//   if (initialized && user && status !== "loading") {
//     return <Navigate to={returnPathFrom(location) || homePathFor(user.role)} replace />;
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     dispatch(clearAuthError());
//     const result = await dispatch(loginUser({ email, password }));

//     if (loginUser.fulfilled.match(result)) {
//       navigate(returnPathFrom(location) || homePathFor(result.payload.role), { replace: true });
//     }
//   };

//   return (
//     <AuthLayout
//       title="Sign in"
//       subtitle="Welcome back. Sign in to continue to your candidates and optimizations."
//       footer={
//         <>
//           New to HirePeaks? <Link to="/register">Create an account</Link>
//         </>
//       }
//     >
//       {error && <AuthAlert tone="error">{error}</AuthAlert>}

//       <form className="au-form" onSubmit={handleSubmit}>
//         <div className="au-field">
//           <label className="au-label" htmlFor="login-email">Email</label>
//           <input
//             id="login-email"
//             className="au-input"
//             type="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             placeholder="you@company.com"
//             autoComplete="email"
//             required
//           />
//         </div>

//         <div className="au-field">
//           <label className="au-label" htmlFor="login-password">Password</label>
//           <PasswordInput
//             id="login-password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             placeholder="Enter your password"
//             autoComplete="current-password"
//           />
//           <div className="au-label-row">
//             <Link to="/forgot-password" className="au-link-small">
//               Forgot password?
//             </Link>
//           </div>
//         </div>

//         <SubmitButton loading={loading} loadingText="Signing in...">
//           Sign in
//         </SubmitButton>
//       </form>
//     </AuthLayout>
//   );
// }

import { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, clearAuthError } from "../slice/authSlice";
import { homePathFor } from "../components/ProtectedRoute";
import AuthLayout, { PasswordInput, SubmitButton, AuthAlert } from "../components/AuthLayout";
import ResendVerification from "../components/ResendVerification";

// The page the user was trying to open before being sent here (set by
// ProtectedRoute). Only internal paths are accepted.
const returnPathFrom = (location) => {
  const from = location.state?.from;
  if (!from?.pathname || !from.pathname.startsWith("/") || from.pathname === "/login") return null;
  return `${from.pathname}${from.search || ""}${from.hash || ""}`;
};

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, initialized, status, error, needsVerification } = useSelector((state) => state.auth);
  const loading = status === "loading";

  // Clear any old error (e.g. from the Register page) when this page opens.
  useEffect(() => {
    dispatch(clearAuthError());
  }, [dispatch]);

  // Already signed in (valid 7-day cookie, e.g. after reopening the browser)?
  // Skip the form and go where they were heading, or to their home page.
  if (initialized && user && status !== "loading") {
    return <Navigate to={returnPathFrom(location) || homePathFor(user.role)} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(clearAuthError());
    const result = await dispatch(loginUser({ email, password }));

    if (loginUser.fulfilled.match(result)) {
      navigate(returnPathFrom(location) || homePathFor(result.payload.role), { replace: true });
    }
  };

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Welcome back. Sign in to continue to your candidates and optimizations."
      footer={
        <>
          New to HirePeaks? <Link to="/register">Create an account</Link>
        </>
      }
    >
      {error && <AuthAlert tone="error">{error}</AuthAlert>}

      {/* Right password, but the email hasn't been verified yet */}
      {needsVerification && <ResendVerification email={email} />}

      <form className="au-form" onSubmit={handleSubmit}>
        <div className="au-field">
          <label className="au-label" htmlFor="login-email">Email</label>
          <input
            id="login-email"
            className="au-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            autoComplete="email"
            required
          />
        </div>

        <div className="au-field">
          <label className="au-label" htmlFor="login-password">Password</label>
          <PasswordInput
            id="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            autoComplete="current-password"
          />
          <div className="au-label-row">
            <Link to="/forgot-password" className="au-link-small">
              Forgot password?
            </Link>
          </div>
        </div>

        <SubmitButton loading={loading} loadingText="Signing in...">
          Sign in
        </SubmitButton>
      </form>
    </AuthLayout>
  );
}